import { Env, Script } from '@didi/utils'

let sdk = null

const resource = {
  web: {
    qatest: 'http://passport.qatest.didichuxing.com/static/trinity-login/1.3.2/login.test.js',
    mainland: '//webapp.didistatic.com/static/webapp/shield/z/trinity-login/trinity-login/1.3.2/login.min.js',
    global: '//img.didiglobal.com/static/passport/shield/z/trinity-login/trinity-login/1.3.2/login.min.js'
  },
  fusion: '//static.udache.com/hybrid-fusion/1.2.1/fusion.js',
  passenger: '//static.udache.com/agility-sdk/1.0.4/bridge.js',
  driver: '//static.udache.com/driver/assets/js/bridge/dbridge.js'
}

export function getLoginSDK(config) {
  return new Promise((resolve, reject) => {
    if (sdk) {
      resolve(sdk)
      return
    }

    if (Env.isPassenger) {
      Script.loadScript(resource.fusion)
        .then(() => {
          return Script.loadScript(resource.passenger)
        })
        .then(() => {
          sdk = window.D.bridge
          resolve(window.D.bridge)
        })
        .catch(error => {
          reject(error)
        })
    } else if (Env.isDriver) {
      Script.loadScript(resource.driver)
        .then(() => {
          sdk = window.didi.dbridge
          resolve(window.didi.dbridge)
        })
        .catch(error => {
          reject(error)
        })
    } else {
      let url = resource.web[config.env] || resource.web.mainland

      Script.loadScript(url)
        .then(() => {
          sdk = window.login
          resolve(window.login)
        })
        .catch(error => {
          reject(error)
        })
    }
  })
}
